import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axios } from "@/client/libs/axios";

type AcceptOptimizationParams = {
  id: string;
};

type AcceptOptimizationResponse = {
  success: boolean;
  message: string;
  resumeId: string;
};

export const acceptOptimization = async (data: AcceptOptimizationParams) => {
  const response = await axios.post<AcceptOptimizationResponse>(
    `/resume-optimizer/accept-optimization/${data.id}`,
    {},
  );
  return response.data;
};

export const useAcceptOptimization = () => {
  const queryClient = useQueryClient();

  const {
    error,
    isPending: loading,
    mutateAsync: acceptOptimizationFn,
  } = useMutation({
    mutationFn: acceptOptimization,
    onSuccess: (_, variables) => {
      // Invalidate relevant queries
      queryClient.invalidateQueries({
        queryKey: ["resume-optimizer", "optimization", variables.id],
      });
      queryClient.invalidateQueries({ queryKey: ["resume", variables.id] });
      queryClient.invalidateQueries({ queryKey: ["resume-analysis", { id: variables.id }] });
    },
  });

  return { acceptOptimization: acceptOptimizationFn, loading, error };
};
